import { bp } from "./breakpoint";
import { classes } from "./classes";
import { overlay } from "./overlay";

export * from "./breakpoint.constant";

type Module = {
  bp: typeof bp
  classes: typeof classes
  overlay: typeof overlay
}

export const module: Module = {
  bp,
  classes,
  overlay
};

export * from "./modifier";
